export const CARD_NA = "NA";

/** Route / list cards — empty, blank, or missing values become NA. */
export const formatTransportRouteCard = (routes) => {
  if (routes == null) return CARD_NA;
  const list = Array.isArray(routes) ? routes : [routes];
  const text = list
    .map((route) => String(route ?? "").trim())
    .filter(Boolean)
    .join(" | ");
  return text || CARD_NA;
};

/** Numeric summary cards — null, undefined, empty, or 0 become NA (unit omitted). */
export const formatTransportMetricCard = (value) => {
  if (value === null || value === undefined || value === "") return CARD_NA;
  const num = Number(value);
  if (Number.isNaN(num) || num === 0) return CARD_NA;
  return num;
};

/** Trip count cards (Road upstream/downstream). */
export const formatTransportCountCard = (value) => formatTransportMetricCard(value);
